<template>
  <transition name="fade">
    <div v-show="visible" class="confirm-mask">
      <div class="confirm-container relative">
        <i class="el-icon-close absolute pointer" style="right: 16px;top: 16px;font-size: 20px;color: #666666" @click="close"></i>
        <p class="title">大模型根据您的指令生成报告</p>
        <div class="question-view">
          <div class="current_radio relative">
            <div class="flex items-center justify-center type-radio">
              <template v-if="questionText && documentName">
                <span :class="{ active: current === 'input' }" @click="current = 'input'">手动输入</span>
                <i>|</i>
                <span :class="{ active: current === 'file'}" @click="current = 'file'">文件</span>
              </template>
              <template v-if="questionText && !documentName">
                <span :class="{ active: current === 'input' }" style="cursor: text">手动输入</span>
              </template>
              <template v-if="!questionText && documentName">
                <span :class="{ active: current === 'file' }" style="cursor: text">文件</span>
              </template>
            </div>
          </div>
          <div class="render-box">
            <p v-if="current === 'input'">{{ questionText }}</p>
            <p v-if="current === 'file'">大模型根据您上传的“{{ documentName }}”文件生成的报告，目前暂不支持文件预览。</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'questionDialog',
  props: {
    questionData: {
      type: String
    },
    documentData: {
      type: String
    }
  },
  data() {
    return {
      visible: false,
      current: '',
      questionText: '',
      documentName: '',
    }
  },
  methods: {
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
  watch: {
    visible: {
      handler(nv) {
        if (nv) {
          this.questionText = this.questionData;
          this.documentName = this.documentData;
          if (this.documentName && !this.questionText) {
            this.current = 'file';
          } else {
            this.current = 'input';
          }
        }
      },
      immediate: true,
      deep: true,
    }
  }
}
</script>

<style lang="less" scoped>
.confirm-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-container {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  width: 580px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.title {
  line-height: 20px;
  margin-bottom: 10px;
  text-align: center;
  color: #666666;
  font-size: 16px;
}

.question-view {
  width: 100%;
  height: 290px;
  border-radius: 10px;
  padding: 14px 0;
  background: #F0F6FE;
  p {
    box-sizing: border-box;
    max-height: 260px;
    padding: 0 12px 0 14px;
    line-height: 23px;
    overflow-y: auto;
  }
}

.render-box {
  width: calc(100% - 2px);
}

.current_radio {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 18px;
  padding-bottom: 12px;
  color: rgba(0, 0, 0, 0.45);

  .el-icon-arrow-left {
    left: -2px;
    top: 1px;
    font-size: 15px;
    user-select: none;
    z-index: 9;
  }

  .type-radio {
    user-select: none;
    span {
      color: rgba(0, 0, 0, 0.5);
      font-size: 15px;
      cursor: pointer;
    }
    i {
      color: #333333;
      font-size: 13px;
      font-style: normal;
      padding: 0 10px;
    }
    .active {
      font-weight: 500;
      color: rgb(2, 38, 224);
    }
  }
}

</style>